<template>
  <div>
    <!-- 业绩归属 -->
    <van-cell title="业绩归属人" is-link @click="addBelongTo()">
      <template>
        <div v-if="list && list.length">已选{{ list.length }}位</div>
        <div v-else style="color: var(--g5)">请选择</div>
      </template>
    </van-cell>

    <van-field
      v-for="(teacher, inx) of list"
      v-model="teacher.scaleStr"
      type="number"
      input-align="right"
      :placeholder="`业绩归属比例(${role.scaleMustFill == 1 ? '必填' : '选填'})`"
      :formatter="belongToNumFormatter"
      :key="teacher.id"
    >
      <template #left-icon>
        <van-icon
          class-prefix="vxs-icon"
          name="system_del"
          color="var(--c3)"
          @click="deleteAch(teacher, inx)"
        />
      </template>
      <template #label>{{ teacher.name }}</template>
      <template #button> % </template>
    </van-field>

    <div style="display: none">{{ errormsg }}</div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'list',
    event: 'change',
  },
  props: {
    // 传入数据
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    errmsg: {
      type: String,
      default: '业绩比例之和必须等于100%'
    }
  },
  data() {
    return {
      dataList: [],
      role: {
        // 业绩比例是否必填 0 否 1 是
        scaleMustFill: '',
        // 业绩比例是否必须等于百分之百 0 否 1 是
        mustEqualOneHundred: '',
      },
    };
  },
  computed: {
    errormsg() {
      let rl = this.role,
        msg = '',
        total = 0;

      if (this.dataList.length > 0) {
        for (let { scaleStr } of this.dataList) {
          if (rl.scaleMustFill == 1) {
            if (scaleStr === '' || scaleStr === undefined) {
              msg = '请填写业绩比例';
              break;
            }
            total += Number(scaleStr);
          }
        }
        if (!msg && rl.scaleMustFill == 1 && rl.mustEqualOneHundred == 1 && total !== 100) {
          msg = this.errmsg;
        }
      }
      this.$emit('error', msg);
      return msg;
    },
  },
  methods: {
    async getRole() {
      let res = await this.$api.findBelongerRule();
      this.role = res.data;
    },
    // 选择业绩归属人(老师/销售)
    async addBelongTo() {
      let res = await app.x3.side.xsTeacher({
        ids: this.dataList.map(item => item.teacherId),
        list: this.dataList,
        params: {
          statusList: [1],
        },
      });

      let arr = [];
      res.list.forEach(teacher => {
        let bool = this.dataList.some(oldTeahcer => {
          if (oldTeahcer.teacherId == teacher.id) {
            arr.push(oldTeahcer);
            return true;
          }
        });

        if (!bool) {
          arr.push({
            teacherId: teacher.id,
            id: teacher.id,
            name: teacher.name,
            scaleStr: '',
          });
        }
      });

      this.dataList = arr;
    },
    // 移除业绩归属人
    deleteAch(teacher, index) {
      this.list.splice(index, 1);
    },
    // 
    belongToNumFormatter(newVal, regx = /^((\d{0,2}(\.\d{0,1})?)|(100))$/) {
      if (regx.test(newVal)) {
        return newVal;
      }

      if (/^(\d{0,3})(\.\d{0,1})?$/.test(newVal)) {
        return 100;
      }
      return newVal.split('').slice(0, -1).join('');
    },
  },
  created() {
    this.getRole();
  },
  watch: {
    // 双向绑定的关键
    list: {
      immediate: true,
      handler: function (nv, ov) {
        if (nv !== ov) {
          this.dataList = this.list;
        }
      },
    },
    dataList: {
      deep: true,
      handler: function (nv, ov) {
        this.$emit('change', this.dataList);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>